<template>
  <div>
    <form @submit.prevent="salvar()" autocomplete="off">
      <div class="row no-gutters align-items-end">
        <div class="col-md-6 mb-2 pr-md-1">
          <label class="small mb-0">Nome</label>
          <input id="nomeTermo" type="text" v-model="dados.nome_termo" class="form-control" placeholder="Ex: Sorvetes" required>
        </div>
        <div class="col-md-6 mb-2 pl-md-1">
          <label class="small mb-0">Valor pesquisado</label>
          <input type="text" v-model="dados.valor" class="form-control" placeholder="Ex: sorvete kg" required>
        </div>
        <div class="col-md-12">
          <button class="btn btn-info btn-block" v-if="!dados.id_termo">Cadastrar</button>
          <div class="d-flex" v-else>
            <div class="w-50 mr-1">
              <button class="btn btn-secondary btn-block" type="button" @click="dados = {nome_termo: '', valor: ''}">Cancelar</button>
            </div>
            <div class="w-50">
              <button class="btn btn-info btn-block">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <hr>
    <div>
      <div v-if="termosRapidos.length">Termos</div>
      <div class="row mt-2">
        <div class="col-md-4 mb-3" v-for="t in termosRapidos">
          <div class="termo border">
            <a href="javascript:" class="close text-dark text-decoration-none" @click="removerTermo(t)">
              <i class="fa fa-times-circle"></i>
            </a>
            <a href="javascript:" class="text-primary text-decoration-none small d-block" @click="editarTermo(t)">
              <i class="fa fa-edit"></i> <span>{{t.nome_termo}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TermosRapidos",
    data() {
      return {
        token: localStorage.getItem('key'),
        editar: false,
        dados: {
          nome_termo: '',
          valor: '',
        }
      }
    },

    methods: {
      buscarTermos() {
        this.$http.get('comandas/termos-rapidos/' + this.token)
          .then(response => {
            this.$store.commit("setTermos", response.data);
            this.$cache.set("termos", response.data);

          }, res => {
            console.log(res);
            this.$store.state.load = false;
          });
      },

      salvar() {
        this.$store.state.load = true;
        this.$http.post('comandas/termos-rapidos/' + this.token, this.dados)
          .then(response => {
            this.$store.state.load = false;
            this.dados = { nome_termo: '', valor: '' };
            this.buscarTermos();

          }, res => {
            console.log(res);
            this.$store.state.load = false;
          });
      },

      removerTermo(t) {
        this.$swal({
          text: 'Deseja realmente remover este termo?',
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.$store.state.load = true;
            this.$http.post('comandas/termos-rapidos/remover/' + this.token, t)
              .then(response => {
                this.$swal("Termo removido com sucesso!");
                this.$store.state.load = false;
                this.buscarTermos();

              }, res => {
                console.log(res);
                this.$store.state.load = false;
              });
          }
        })
      },

      editarTermo(t) {
        if (!t.id_termo) {
          return;
        }

        this.dados = {
          id_termo: t.id_termo,
          nome_termo: t.nome_termo,
          valor: t.valor
        }
      }
    },

    mounted() {
      this.buscarTermos();
    },

    computed: {
      termosRapidos() {
        return this.$store.state.termosRapidos
      }
    }
  }
</script>

<style scoped>
  .termo {
    display: block;
    padding: 12px 16px;
    position: relative;
    border-radius: 6px;
  }

  .termo .close {
    position: absolute;
    top: -12px;
    right: -12px;
  }
</style>
